import * as React from "react"
import * as Model from "../.././../../model";
import PolitiqueCardComponent from "./politique-card-component"
import { Props } from "@fortawesome/react-fontawesome"
// import { CardModalNotOkButton } from "../../../modal";

class PolitiqueCard extends React.Component<PolitiqueCardProps, Props> {
	constructor(props) {
		super(props)
	}

	render() {
		return <PolitiqueCardComponent 
		consulted={this.props.consulted}
		loading={this.props.loading}
		localAuthority={this.props.localAuthority}
		onClickChanges={this.props.onClickPolitiqueChanges}
		onClickViewPolitique={this.props.onClickViewPolitique} />
	}
}


export default PolitiqueCard

export interface PolitiqueCardProps {
	consulted: boolean
	loading?: boolean
	onClickViewPolitique(event: React.SyntheticEvent<Element>): void
	localAuthority: Model.LocalAuthority
	onClickPolitiqueChanges(event: React.SyntheticEvent<Element>): void
	
}

interface State {
}


// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/politique-card/index.tsx